export default {
  // list
  'base_cargo_type.query.cargoTypeName': '货物类型',
  'base_cargo_type.query.cargoTypeName.placeholder': '请输入货物类型',
  'base_cargo_type.column.cargoTypeName': '货物类型',
  'base_cargo_type.column.createBy': '创建人',
  'base_cargo_type.column.updateBy': '更新人',
  'base_cargo_type.column.createTime': '创建时间',
  'base_cargo_type.column.updateTime': '更新时间',
  'base_cargo_type.column.dataSource': '数据来源',
  'base_cargo_type.column.remark': '备注',
  'base_cargo_type.column.status': '状态',
  // edit
  'base_cargo_type.edit.title': '编辑货物类型',
  'base_cargo_type.add.title': '新增货物类型',
  'base_cargo_type.edit.success': '编辑成功',
  'base_cargo_type.add.success': '新增成功',
  'base_cargo_type.form.cargoTypeName.required': '货物类型不能为空',
  'base_cargo_type.form.cargoTypeName': '货物类型',
  'base_cargo_type.form.cargoTypeName.placeholder': '请输入货物类型',
}
